import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { FloatingProductBox } from '../components/FloatingProductBox';
import { ProductCategories } from '../components/ProductCategories';
import { IndustrySection } from '../components/IndustrySection';
import { TechnologySection } from '../components/TechnologySection';
import { PackagingShowcase } from '../components/PackagingShowcase';
import { EcoFriendlySection } from '../components/EcoFriendlySection';
import { Testimonials } from '../components/Testimonials';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';

export const Home: React.FC = () => {
  return (
    <main>
      <SEO 
        title="PrintAura - Premium Mono-Carton Packaging Solutions"
        description="PrintAura specializes in premium mono-carton packaging, custom boxes, and sustainable printing solutions for luxury brands. High-precision packaging for cosmetics, electronics, food & beverages."
        keywords="packaging, mono-cartons, custom boxes, printing, premium packaging, sustainable packaging, luxury packaging, PrintAura"
        url="https://printaura.co.in"
      />
      <FloatingProductBox />
      <Hero />
      <Features />
      <ProductCategories />
      <IndustrySection />
      <TechnologySection />
      <PackagingShowcase />
      <EcoFriendlySection />
      <Testimonials />
      <Footer />
    </main>
  );
};
